module.exports = __webpack_public_path__ + "static/media/user-icon.efcd42d6.png";